import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f624d55c"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f624d55c')) {
      api.createRecord('f624d55c', component.options)
    } else {
      api.reload('f624d55c', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=f624d55c", function () {
      api.rerender('f624d55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/file/home.vue"
export default component.exports